import { useUserStore } from '@/stores/user'
import JwtService from '@/services/JwtService'

export const isAuthChecker = (to, from, next) => {
    const { redirectionRoute } = useUserStore()
    const isAuthenticated = !!JwtService.getToken()

    if (isAuthenticated) {
        return next({ name: redirectionRoute })
    }

    return next()
}
